var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-table',{attrs:{"header":"معاملات","icon":"Trades","tabs":_vm.tabs,"columns":_vm.columns,"items":_vm.items},scopedSlots:_vm._u([{key:"cell(icon)",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"d-flex-r-jc-ac"},[_c('inline-svg',{attrs:{"width":"21","src":require(("@/assets/Icons/" + (item.type) + "-icon.svg"))}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }